const assertRectangle = (area) => {
  if (area.width < 0 || area.height < 0) {
    console.error('Invalid area', area);

    throw new Error('bad area');
  }
};

export default assertRectangle;
